module.exports = __webpack_public_path__ + "img/traffic-total1.4fff4a37.svg";